import { inject } from 'vue';

export const ANALYSIS_SAJU_CONTEXT = Symbol('analysisSajuContext');
export const useAnalysisSajuContext = () => inject(ANALYSIS_SAJU_CONTEXT, null);

export const getHarmonyBaseId = (log) => {
  const members = [...(log?.members || [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
  return Number(members[0]?.guestUserId || log?.guestUserId) || null;
};

export const toAnalysisPerson = (saju) => saju ? {
  ...saju,
  guestUserId: Number(saju.guestUserId),
  name: saju.guestUserName || saju.name || '',
  solar: saju.solar || saju.birthday || saju.birth || '',
} : null;

export const analysisServiceForMenu = (menu) => {
  if (menu === '/overviewNangmanHarmony' || menu === '/nangman-harmony') return 'harmony';
  if (menu === '/overviewNangmanNaming' || menu === '/saju-naming') return 'naming';
  return null;
};
